import React from 'react';
import { Neo, NeoGrid } from '@singularsystems/neo-react';
import { observer } from 'mobx-react';
import { TextConstants } from '../../../Common/TextConstants';
import AssignEventComponentVM from './AssignEventComponentVM';
import StaticEventLookup from '../Models/StaticEventSearchModal/StaticEventLookup';
import EventMappingLookup from '../Models/EventMappingLookup';
import Loading from '../../../App/Components/Loading/Loading';
import ManageStaticEventComponent from '../../../Maintenance/StaticEvents/Components/ManageStaticEventComponent';

interface IAssignEventComponentProps {
    viewModel: AssignEventComponentVM;
    eventMappingUpdateList: EventMappingLookup[];
    onBack: () => void;
    onSave: () => void;
    onCreationOfNewEvent: () => void;
    onEventSearch: () => void;
}

@observer
export default class AssignEventComponent extends React.Component<IAssignEventComponentProps> {
    public render() {
        var viewModel = this.props.viewModel;
        viewModel.eventMappingUpdateList = this.props.eventMappingUpdateList;

        return (
            <>
                {(viewModel.taskRunner.isBusy) && <Loading />}
                <Neo.Modal
                    title={TextConstants.Buttons.CreateAsEvent}
                    bind={viewModel.meta.showAddNewEventModalInd}
                    size="xl">
                    <ManageStaticEventComponent
                        viewModel={viewModel.manageStaticEventComponentVM}
                        onCancel={() => viewModel.closeAddEventModal()}
                        onSave={() => this.props.onCreationOfNewEvent()} 
                        eventName={viewModel.eventName}/>
                </Neo.Modal>
                <Neo.Card title={TextConstants.Titles.AssignEvent}>
                    <div className="row p-3">
                        <NeoGrid.Grid items={this.props.eventMappingUpdateList}>
                            {(item, meta) => (
                                <NeoGrid.Row>
                                    <NeoGrid.Column display={meta.stockBroker} label={TextConstants.Labels.Broker} />
                                    <NeoGrid.Column display={meta.securityOrCash} />
                                    <NeoGrid.Column display={meta.fileType} />
                                    <NeoGrid.Column display={meta.eventType} />
                                    <NeoGrid.Column display={meta.corporateActionType} />
                                    <NeoGrid.Column display={meta.adhocBookingType} />
                                    <NeoGrid.Column display={meta.buyOrSell} />
                                    <NeoGrid.Column display={meta.isPositiveValue} />
                                    <NeoGrid.ButtonColumn>
                                        <Neo.Button onClick={() => viewModel.showAddEventModal(meta.eventType.value)}>{TextConstants.Buttons.CreateAsEvent}</Neo.Button>
                                    </NeoGrid.ButtonColumn>
                                </NeoGrid.Row>
                            )}
                        </NeoGrid.Grid>
                    </div>
                    <Neo.Form onSubmit={() => viewModel.eventMappingSearchCriteria.meta.searchCriteria.value === "" ? viewModel.pageManager.refreshData() : viewModel.clearSearch()}>
                        <Neo.FormGroup bind={viewModel.eventMappingSearchCriteria.meta.searchCriteria}
                            onKeyUp={() => this.props.onEventSearch()}
                            placeholder={TextConstants.PlaceHolder.SearchEvent}
                            suppressLabel={true}
                            append={<Neo.Button isSubmit>
                                <i className={`${viewModel.eventMappingSearchCriteria.meta.searchCriteria.value === "" ? "fa fa-search" : "fa fa-times-circle"}`} />
                            </Neo.Button>} />
                    </Neo.Form>

                    <Neo.Pager pageManager={viewModel.pageManager} pageControlProps={{ pageSizeLabel: "Show: " }}>
                        <div className="horizontalScroll">
                            <NeoGrid.Grid<StaticEventLookup> className={"table-striped"}>
                                {(item, meta) => (
                                    <NeoGrid.Row key={item.staticEventID}>
                                        <NeoGrid.Column display={meta.staticEventName} label={TextConstants.Labels.EventName} />
                                        <NeoGrid.Column display={meta.isCapitalGainEventInd} label={TextConstants.Labels.CapitalGainEvent} />
                                        <NeoGrid.Column display={meta.isCashFlowInd} label={TextConstants.Labels.CashFlow} />
                                        <NeoGrid.Column display={meta.isQuantityNotValueInd} label={TextConstants.Labels.QuantityNotValue} />
                                        <NeoGrid.Column display={meta.isDividendEventInd} label={TextConstants.Labels.Dividend} />
                                        <NeoGrid.Column display={meta.isSellAtBookCostEventInd} label={TextConstants.Labels.SellAtBookCost} />
                                        <NeoGrid.Column display={meta.isZeroPriceEventInd} label={TextConstants.Labels.ZeroPrice} />
                                        <NeoGrid.Column display={meta.isDWTInd} label={TextConstants.Labels.DWT} />
                                        <NeoGrid.Column display={meta.isInterestInd} label={TextConstants.Labels.Interest} />
                                        <NeoGrid.Column bind={meta.selected} input={{ type: "switch" }} onChange={() => { viewModel.SelectGenericEvent(item) }} sort={false} label={TextConstants.Labels.Assign} />
                                    </NeoGrid.Row>
                                )}
                            </NeoGrid.Grid>
                        </div>
                    </Neo.Pager>
                    <div className="row customMarginTop29 float-right pr-3">
                                <Neo.Button 
                                    variant="primary" className="ml-3 col-md-2"
                                    onClick={() => this.props.onSave()}
                                >{TextConstants.Buttons.Save}</Neo.Button>
                                <Neo.Button className="ml-3 col-md-2"
                                    onClick={() => this.props.onBack()}
                                    variant="secondary"
                                >{TextConstants.Buttons.Cancel}</Neo.Button>
                            </div>
                </Neo.Card>
            </>
        );
    }
}